import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getFeatureFlag } from "@charphq/ui/utils/featureFlags";

/**
 * Layout for the `/experiments` tree.
 *
 * Deliberately thin: every experiment renders its own `ExperimentShell`, which
 * carries the header, filter bar and canvas. All this layer does is host the
 * outlet inside the app's normal page padding, so experiments sit in the same
 * chrome as every other page.
 *
 * The flag is enforced **here** as well as in the nav. Hiding the sidebar entry
 * alone would leave every experiment reachable by URL, so "switch the group off
 * for a customer-facing session" would not actually hold for anyone who has a
 * link. Guarding the parent covers the gallery and all six children at once.
 *
 * The check is a synchronous read of an in-memory flag — `beforeLoad` runs on
 * every router activity, so it must not reach for the network.
 */
export const Route = createFileRoute("/experiments")({
  beforeLoad: () => {
    if (!getFeatureFlag("experiments_gallery")) {
      throw redirect({ to: "/" });
    }
  },
  component: ExperimentsLayout,
});

function ExperimentsLayout() {
  return (
    <div className="p-6">
      <Outlet />
    </div>
  );
}
